<template>
  <kst-section list-mode :title="Info.Section.Variant.Title">
    <List :user-variant-list="userVariantList"/>
  </kst-section>
</template>

<script>
import Info from "../ItemInfo.js";
import Model from "../ItemModel.js";

import List from "./ItemN_Variant_List.vue";

export default {
  components: {
    List
  },
  props: {
    userVariantList: Array
  },
  data: () => ({
    Info: Info,
    Model: Model
  })
}
</script>